module.exports = __webpack_public_path__ + "img/bible-study.7b34e76d.jpeg";